export const ChevronRightIcon = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
    <path d="M2.91602 0.916626L6.92643 5.49996L2.91602 10.0833" stroke="currentColor" strokeLinecap="round"/>
  </svg>
)
